import React from 'react';
// icons
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
// components
import ToolBarButton from '../ui/toolbar/toolBarButton';
import ToolbarTitle from '../ui/toolbar/toolbarTitle';
import { useHistory } from 'react-router-dom';
import ToolbarContainer from '../ui/containers/toolbarContainer';

const t = {
  new_filter_view: 'New filter view',
};
const NewFilterViewToolbar = ({ className }) => {
  let history = useHistory();

  return (
    <ToolbarContainer>
      <ToolbarTitle>{t.new_filter_view}</ToolbarTitle>
      <ToolBarButton
        onClick={() => {
          history.push('/emergencies/filter-views');
        }}
      >
        <CloseIcon />
      </ToolBarButton>
    </ToolbarContainer>
  );
};

export default NewFilterViewToolbar;
